import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { setAlert } from "../../action/alert";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CreateDealer from "./createDealer";
import GetDealerInfo from "./getDealerInfo";
import UploadPSNDealerMapping from './uploadPSNDealerMapping'
import { uploadPSNDealerFile } from "../../action/deviceDealer";
import customConfig from "../../config";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import { Box } from "@mui/material";

const activeTabSx = { border: '1px solid #bdbdbd', backgroundColor: '#e0e0e0', color: '#333333', textTransform: 'capitalize' };
const nonActiveTabSx = { border: 'none', backgroundColor: 'none', color: '#333333', textTransform: 'capitalize' };

const DeviceDealerMgmt = ({
    wrapperClass,
    allowedDeviceCategories,
    allowedCompanyBrand,
    allowedCountries,
    setAlert,
    deviceDealer,
    uploadPSNDealerFile,
    userRoleInfo,
}) => {
    const [activeTab, setActiveTab] = React.useState(0)
    const [deviceDealerDetails, setDeviceDealerDetails] = useState({})
    const [editDeviceDealerDetails, setEditDeviceDealerDetails] = useState(false)

    const [showUpdatedDealerInfo, setShowUpdatedDealerInfo] = useState(false)

    useEffect(() => {
        if (activeTab !== 0) {
            // active tab 0 is create/edit
            // whenever the tab is changed/switched then reset the tab configs

            setEditDeviceDealerDetails(false)
            setDeviceDealerDetails({})
        }
    }, [activeTab])

    function handleEditDeviceDealerDetails(deviceDealerDetails) {
        setDeviceDealerDetails(deviceDealerDetails)
        setEditDeviceDealerDetails(true)
        setActiveTab(0)
        setShowUpdatedDealerInfo(false)
    }

    function handleCancelEditDeviceDealerDetails() {
        setActiveTab(1) // get back to details page
        setEditDeviceDealerDetails(false)
        setDeviceDealerDetails({})
        setShowUpdatedDealerInfo(true)
    }

    return (
        <ResponsiveContentWrapper className={wrapperClass || ""}>
            <Box className="row" sx={{ width: "100%", minWidth: 0 }}>
                <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => {
                        setActiveTab(newValue)
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: "#bdbdbd"
                        }
                    }}
                    style={{ marginTop: 0 }}
                >
                    {
                        (userRoleInfo.level > 4 || userRoleInfo.roles.includes(customConfig.roleCloudAdmin)) &&
                        <Tab label="Create Dealer" sx={activeTab == 0 ? activeTabSx : nonActiveTabSx} />
                    }
                    <Tab label="Get Dealer Information" sx={activeTab == 1 ? activeTabSx : nonActiveTabSx} />
                    {
                        (userRoleInfo.level > 4 || userRoleInfo.roles.includes(customConfig.roleCloudAdmin)) &&
                        <Tab label="Upload PSN Dealer Mapping" sx={activeTab == 2 ? activeTabSx : nonActiveTabSx} />
                    }
                </Tabs>
                {
                    (userRoleInfo.level > 4 || userRoleInfo.roles.includes(customConfig.roleCloudAdmin)) ? <Fragment>
                        <div hidden={activeTab !== 0}>
                            <CreateDealer
                                allowedDeviceCategories={allowedDeviceCategories}
                                allowedCompanyBrand={allowedCompanyBrand}
                                allowedCountries={allowedCountries}
                                setAlert={setAlert}
                                editDeviceDealerDetails={editDeviceDealerDetails}
                                deviceDealerDetails={deviceDealerDetails}
                                cancelEditDeviceDealerDetails={handleCancelEditDeviceDealerDetails}
                            ></CreateDealer>
                        </div>
                        <div hidden={activeTab !== 1}>
                            <GetDealerInfo
                                allowedDeviceCategories={allowedDeviceCategories}
                                allowedCompanyBrand={allowedCompanyBrand}
                                allowedCountries={allowedCountries}
                                setAlert={setAlert}
                                onEditDeviceDealerDetails={handleEditDeviceDealerDetails}
                                showUpdatedDealerInfo={showUpdatedDealerInfo}
                                userRoleInfo={userRoleInfo}
                            ></GetDealerInfo>
                        </div>
                        <div hidden={activeTab !== 2}>
                            <UploadPSNDealerMapping
                                allowedDeviceCategories={allowedDeviceCategories}
                                allowedCompanyBrand={allowedCompanyBrand}
                                allowedCountries={allowedCountries}
                                setAlert={setAlert}
                                deviceDealer={deviceDealer}
                                uploadPSNDealerFile={uploadPSNDealerFile}
                            ></UploadPSNDealerMapping>
                        </div>
                    </Fragment>
                        :
                        <Fragment>
                            <div hidden={activeTab !== 0}>
                                <GetDealerInfo
                                    allowedDeviceCategories={allowedDeviceCategories}
                                    allowedCompanyBrand={allowedCompanyBrand}
                                    allowedCountries={allowedCountries}
                                    setAlert={setAlert}
                                    onEditDeviceDealerDetails={handleEditDeviceDealerDetails}
                                    showUpdatedDealerInfo={showUpdatedDealerInfo}
                                    userRoleInfo={userRoleInfo}
                                ></GetDealerInfo>
                            </div>
                        </Fragment>
                }

            </Box>
        </ResponsiveContentWrapper>
    );
}

const mapStateToProps = (state) => ({
    allowedDeviceCategories: state.auth.allowedDeviceCategories,
    allowedCompanyBrand: state.auth.allowCompanyBrand,
    allowedCountries: state.auth.allowedCountries,
    deviceDealer: state.deviceDealer,
    userRoleInfo: {
        level: state.auth.userLevel,
        roles: state.auth.userRoles,
    },
});

const mapDispatchToProps = (dispatch) => ({
    setAlert: (message, status) => dispatch(setAlert(message, status)),
    uploadPSNDealerFile: (formData) => dispatch(uploadPSNDealerFile(formData))
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDealerMgmt);